var EnrollmentService = function() {
  this.parseEnrollment = function(model, response) {
    return response;
  };

  this.saveData = function(model, options, dataObj) {
    if(dataObj.hasChanged()) {
      dataObj.save(null, options);
    }
  };
};

module.exports = new EnrollmentService();
